import { createSlice } from "@reduxjs/toolkit";

import { updateFreeLookups } from "../../features/profile/profileSlice";

import { api } from "../../api";

const initialState = {
  query: null,
  searchResult: null,
  searchLoading: false,
  searchError: null,
  data: null,
  purchaseLoading: false,
  purchaseError: null,
  autoCompleteLoading: false,
  autoCompleteResult: null,
  autoCompleteError: null,
  autoCompleteLoadingForContractor: false,
  autoCompleteErrorForContractor: null,
  autoCompleteResultForContractor: null,
  autoCompleteLoadingForArchitect: false,
  autoCompleteErrorForArchitect: null,
  autoCompleteResultForArchitect: null,
  autoCompleteLoadingForEngineer: false,
  autoCompleteErrorForEngineer: null,
  autoCompleteResultForEngineer: null,
  autoCompleteLoadingForDesigner: false,
  autoCompleteErrorForDesigner: null,
  autoCompleteResultForDesigner: null,
};

export const apiLookupSlice = createSlice({
  name: "apiLookup",
  initialState,
  reducers: {
    apiSearchStart: (state, action) => {
      state.query = action.payload;
      state.searchResult = null;
      state.searchLoading = true;
      state.searchError = null;
      state.data = null;
      state.purchaseError = null;
    },
    apiSearchSuccess: (state, action) => {
      state.searchLoading = false;
      state.searchResult = action.payload;
    },
    apiSearchFailed: (state, action) => {
      state.searchLoading = false;
      state.searchError = action.payload;
    },
    apiPurchaseStart: (state, action) => {
      state.purchaseLoading = true;
      state.purchaseError = null;
      state.data = null;
    },
    apiPurchaseSuccess: (state, action) => {
      state.purchaseLoading = false;
      state.data = action.payload;
    },
    apiPurchaseFailed: (state, action) => {
      state.purchaseLoading = false;
      state.purchaseError = action.payload;
    },
    apiAutoCompleteStart: (state, action) => {
      state.autoCompleteLoading = true;
      state.autoCompleteError = null;
      state.autoCompleteResult = null;
    },
    apiAutoCompleteSuccess: (state, action) => {
      state.autoCompleteLoading = false;
      state.autoCompleteResult = action.payload;
    },
    apiAutoCompleteFailed: (state, action) => {
      state.autoCompleteLoading = false;
      state.autoCompleteError = action.payload;
    },
    apiAutoCompleteStartForContractor: (state, action) => {
      state.autoCompleteLoadingForContractor = true;
      state.autoCompleteErrorForContractor = null;
      state.autoCompleteResultForContractor = null;
    },
    apiAutoCompleteSuccessForContractor: (state, action) => {
      state.autoCompleteLoadingForContractor = false;
      state.autoCompleteResultForContractor = action.payload;
    },
    apiAutoCompleteFailedForContractor: (state, action) => {
      state.autoCompleteLoadingForContractor = false;
      state.autoCompleteErrorForContractor = action.payload;
    },
    apiAutoCompleteStartForArchitect: (state, action) => {
      state.autoCompleteLoadingForArchitect = true;
      state.autoCompleteErrorForArchitect = null;
      state.autoCompleteResultForArchitect = null;
    },
    apiAutoCompleteSuccessForArchitect: (state, action) => {
      state.autoCompleteLoadingForArchitect = false;
      state.autoCompleteResultForArchitect = action.payload;
    },
    apiAutoCompleteFailedForArchitect: (state, action) => {
      state.autoCompleteLoadingForArchitect = false;
      state.autoCompleteErrorForArchitect = action.payload;
    },
    apiAutoCompleteStartForDesigner: (state, action) => {
      state.autoCompleteLoadingForDesigner = true;
      state.autoCompleteErrorForDesigner = null;
      state.autoCompleteResultForDesigner = null;
    },
    apiAutoCompleteSuccessForDesigner: (state, action) => {
      state.autoCompleteLoadingForDesigner = false;
      state.autoCompleteResultForDesigner = action.payload;
    },
    apiAutoCompleteFailedForDesigner: (state, action) => {
      state.autoCompleteLoadingForDesigner = false;
      state.autoCompleteErrorForDesigner = action.payload;
    },
    apiAutoCompleteStartForEngineer: (state, action) => {
      state.autoCompleteLoadingForEngineer = true;
      state.autoCompleteErrorForEngineer = null;
      state.autoCompleteResultForEngineer = null;
    },
    apiAutoCompleteSuccessForEngineer: (state, action) => {
      state.autoCompleteLoadingForEngineer = false;
      state.autoCompleteResultForEngineer = action.payload;
    },
    apiAutoCompleteFailedForEngineer: (state, action) => {
      state.autoCompleteLoadingForEngineer = false;
      state.autoCompleteErrorForEngineer = action.payload;
    },
    clear: () => initialState,
  },
});

export const {
  apiSearchStart,
  apiSearchSuccess,
  apiSearchFailed,
  apiPurchaseStart,
  apiPurchaseSuccess,
  apiPurchaseFailed,
  apiAutoCompleteStart,
  apiAutoCompleteSuccess,
  apiAutoCompleteFailed,
  apiAutoCompleteStartForContractor,
  apiAutoCompleteSuccessForContractor,
  apiAutoCompleteFailedForContractor,
  apiAutoCompleteStartForArchitect,
  apiAutoCompleteSuccessForArchitect,
  apiAutoCompleteFailedForArchitect,
  apiAutoCompleteStartForDesigner,
  apiAutoCompleteSuccessForDesigner,
  apiAutoCompleteFailedForDesigner,
  apiAutoCompleteStartForEngineer,
  apiAutoCompleteSuccessForEngineer,
  apiAutoCompleteFailedForEngineer,
  clear,
} = apiLookupSlice.actions;

export default apiLookupSlice.reducer;

export const selectApiSearchQuery = (state) => state.apiLookup.query;
export const selectApiSearchResult = (state) => state.apiLookup.searchResult;
export const selectApiSearchLoading = (state) => state.apiLookup.searchLoading;
export const selectApiSearchError = (state) => state.apiLookup.searchError;

export const selectApiPurchaseData = (state) => state.apiLookup.data;
export const selectApiPurchaseLoading = (state) =>
  state.apiLookup.purchaseLoading;
export const selectApiPurchaseError = (state) => state.apiLookup.purchaseError;

export const selectAutoCompleteResult = (state) =>
  state.apiLookup.autoCompleteResult;
export const selectAutoCompleteLoading = (state) =>
  state.apiLookup.autoCompleteLoading;
export const selectAutoCompleteError = (state) =>
  state.apiLookup.autoCompleteError;

export const selectAutoCompleteResultForContractor = (state) =>
  state.apiLookup.autoCompleteResultForContractor;
export const selectAutoCompleteLoadingForContractor = (state) =>
  state.apiLookup.autoCompleteLoadingForContractor;
export const selectAutoCompleteErrorForContractor = (state) =>
  state.apiLookup.autoCompleteErrorForContractor;

export const selectAutoCompleteResultForArchitect = (state) =>
  state.apiLookup.autoCompleteResultForArchitect;
export const selectAutoCompleteLoadingForArchitect = (state) =>
  state.apiLookup.autoCompleteLoadingForArchitect;
export const selectAutoCompleteErrorForArchitect = (state) =>
  state.apiLookup.autoCompleteErrorForArchitect;

export const selectAutoCompleteResultForEngineer = (state) =>
  state.apiLookup.autoCompleteResultForEngineer;
export const selectAutoCompleteLoadingForEngineer = (state) =>
  state.apiLookup.autoCompleteLoadingForEngineer;
export const selectAutoCompleteErrorForEngineer = (state) =>
  state.apiLookup.autoCompleteErrorForEngineer;

export const selectAutoCompleteResultForDesigner = (state) =>
  state.apiLookup.autoCompleteResultForDesigner;
export const selectAutoCompleteLoadingForDesigner = (state) =>
  state.apiLookup.autoCompleteLoadingForDesigner;
export const selectAutoCompleteErrorForDesigner = (state) =>
  state.apiLookup.autoCompleteErrorForDesigner;

export const apiLookupSearch = (query) => async (dispatch, getState) => {
  dispatch(apiSearchStart(query));

  const state = getState();
  const token = state.profile.info.apiTokens[0];

  try {
    const data = await api("/api/v3/search", { token, query });
    dispatch(apiSearchSuccess(data));
  } catch (err) {
    dispatch(apiSearchFailed(err.message));
  }
};

export const apiLookupPurchase = () => async (dispatch, getState) => {
  dispatch(apiPurchaseStart());

  const state = getState();
  const token = state.profile.info.apiTokens[0];
  const { query, searchResult } = state.apiLookup;
  const { count } = searchResult;

  try {
    const data = await api("/api/v3/purchase", { token, query, count });
    dispatch(apiPurchaseSuccess(data));
    dispatch(updateFreeLookups(data.free_lookups));
  } catch (err) {
    dispatch(apiPurchaseFailed(err.message));
  }
};

export const apiAutocompleteSearch = (query) => async (dispatch) => {
  dispatch(apiAutoCompleteStart(query));

  try {
    const data = await api(
      "/api/proxy",
      {
        query,
      },
      true
    );
    dispatch(apiAutoCompleteSuccess(data));
  } catch (err) {
    dispatch(apiAutoCompleteFailed(err.message));
  }
};

export const apiAutocompleteSearchForContractor =
  (query) => async (dispatch) => {
    dispatch(apiAutoCompleteStartForContractor(query));

    try {
      const data = await api(
        "/api/contractor-suggestion",
        {
          query,
        },
        true
      );
      dispatch(apiAutoCompleteSuccessForContractor(data));
    } catch (err) {
      dispatch(apiAutoCompleteFailedForContractor(err.message));
    }
  };

export const apiAutocompleteSearchForArchitect =
  (query) => async (dispatch) => {
    dispatch(apiAutoCompleteStartForArchitect(query));

    try {
      const data = await api(
        "/api/architect-suggestion",
        {
          query,
        },
        true
      );
      dispatch(apiAutoCompleteSuccessForArchitect(data));
    } catch (err) {
      dispatch(apiAutoCompleteFailedForArchitect(err.message));
    }
  };

export const apiAutocompleteSearchForEngineer = (query) => async (dispatch) => {
  dispatch(apiAutoCompleteStartForEngineer(query));

  try {
    const data = await api(
      "/api/engineer-suggestion",
      {
        query,
      },
      true
    );
    dispatch(apiAutoCompleteSuccessForEngineer(data));
  } catch (err) {
    dispatch(apiAutoCompleteFailedForEngineer(err.message));
  }
};

export const apiAutocompleteSearchForDesigner = (query) => async (dispatch) => {
  dispatch(apiAutoCompleteStartForDesigner(query));

  try {
    const data = await api(
      "/api/designer-suggestion",
      {
        query,
      },
      true
    );
    dispatch(apiAutoCompleteSuccessForDesigner(data));
  } catch (err) {
    dispatch(apiAutoCompleteFailedForDesigner(err.message));
  }
};
